
import { db, auth, storage } from './firebase.js';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { collection, query, orderBy, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

let quill;

// Initialize
initQuill();
setupEventListeners();

function initQuill() {
    if (typeof Quill === 'undefined') {
        console.error("Quill not loaded");
        return;
    }
    quill = new Quill('#editor-container', {
        theme: 'snow',
        modules: {
            toolbar: [
                [{ 'header': [2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ['link', 'image'],
                ['clean']
            ]
        },
        placeholder: 'Anlatmaya başlayın...'
    });
}

// Authentication Logic
onAuthStateChanged(auth, (user) => {
    const overlay = document.getElementById('login-overlay');
    if (user) {
        if (overlay) overlay.style.display = 'none';
        renderAdminList();
    } else {
        if (overlay) overlay.style.display = 'flex';
    }
});

window.checkAuth = async function () {
    const emailInput = document.getElementById('admin-user');
    const passwordInput = document.getElementById('admin-pass');
    const errorEl = document.getElementById('login-error');
    const loadingEl = document.getElementById('login-loading');

    const email = emailInput.value;
    const password = passwordInput.value;
    let finalEmail = email.includes('@') ? email : "lechat_superuser_2026@lechatbot.com";

    errorEl.style.display = 'none';
    loadingEl.style.display = 'block';

    try {
        await signInWithEmailAndPassword(auth, finalEmail, password);
    } catch (error) {
        loadingEl.style.display = 'none';
        errorEl.textContent = "Giriş başarısız!";
        errorEl.style.display = 'block';
    }
}

window.logout = async function () {
    await signOut(auth);
    location.reload();
}

// Tab Logic
window.switchTab = function (tabName) {
    document.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
    document.querySelectorAll('.admin-section').forEach(sec => sec.classList.remove('active'));

    const activeBtn = document.querySelector(`.tab-btn[onclick*="${tabName}"]`);
    const activeSec = document.getElementById(`section-${tabName}`);

    if (activeBtn) activeBtn.classList.add('active');
    if (activeSec) activeSec.classList.add('active');

    if (tabName === 'posts') renderAdminList();
    if (tabName === 'references') renderReferencesAdmin();
    if (tabName === 'services') renderServicesAdmin();
}

// Posts Management
window.renderAdminList = async function () {
    const list = document.getElementById('posts-list');
    if (!list) return;
    list.innerHTML = '<p>Yükleniyor...</p>';

    try {
        const querySnapshot = await getDocs(collection(db, "posts"));
        let docs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        docs.sort((a, b) => {
            const parseDate = (dStr) => {
                if (!dStr) return 0;
                const d = new Date(dStr);
                if (!isNaN(d.getTime())) return d.getTime();
                const parts = dStr.split('/');
                if (parts.length === 3) return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).getTime();
                return 0;
            };
            return parseDate(b.date) - parseDate(a.date);
        });

        list.innerHTML = '';
        docs.forEach((post) => {
            const item = document.createElement('div');
            item.className = 'post-list-item';
            item.innerHTML = `
                <div class="post-info">
                    <h4>${post.title}</h4>
                    <span>${post.category} • ${post.date || ''}</span>
                </div>
                <div class="actions">
                    <button class="btn-icon" onclick="editPost('${post.id}')"><i data-lucide="edit"></i></button>
                    <button class="btn-icon delete" onclick="deletePost('${post.id}')"><i data-lucide="trash"></i></button>
                </div>
            `;
            list.appendChild(item);
        });
        if (typeof lucide !== 'undefined') lucide.createIcons();
    } catch (error) { console.error(error); }
}

window.showNewForm = function () {
    document.getElementById('post-form').reset();
    document.getElementById('edit-id').value = '';
    if (quill) quill.setContents([]);
    document.getElementById('editor').style.display = 'block';
    window.scrollTo(0, 0);
}

window.cancelEdit = function () {
    document.getElementById('editor').style.display = 'none';
}

window.editPost = async function (id) {
    const docSnap = await getDoc(doc(db, "posts", id));
    if (!docSnap.exists()) return;
    const post = docSnap.data();

    document.getElementById('edit-id').value = id;
    document.getElementById('title').value = post.title;
    document.getElementById('category').value = post.category;
    document.getElementById('excerpt').value = post.excerpt;
    document.getElementById('tldr').value = post.tldr || '';
    document.getElementById('image').value = post.image;
    document.getElementById('author').value = post.author || 'Le Chatbot';
    document.getElementById('date').value = post.date;

    if (post.content && quill) quill.clipboard.dangerouslyPasteHTML(post.content);
    document.getElementById('editor').style.display = 'block';
    window.scrollTo(0, 0);
}

window.deletePost = async function (id) {
    if (confirm('Silmek istediğinize emin misiniz?')) {
        await deleteDoc(doc(db, "posts", id));
        renderAdminList();
    }
}

// References Management
window.renderReferencesAdmin = async function () {
    const list = document.getElementById('ref-list');
    if (!list) return;
    try {
        const q = query(collection(db, "references"), orderBy("order", "asc"));
        const snap = await getDocs(q);
        list.innerHTML = '';
        snap.forEach(docSnap => {
            const refData = docSnap.data();
            const card = document.createElement('div');
            card.className = 'ref-card';
            card.innerHTML = `
                <div style="display: flex; align-items: center; gap: 1rem;">
                    <img src="${refData.logo}" height="40">
                    <span>${refData.name}</span>
                </div>
                <button class="btn-icon delete" onclick="deleteReference('${docSnap.id}')"><i data-lucide="trash"></i></button>
            `;
            list.appendChild(card);
        });
        if (typeof lucide !== 'undefined') lucide.createIcons();
    } catch (err) { console.error(err); }
}

window.deleteReference = async function (id) {
    if (confirm('Silmek istediğinize emin misiniz?')) {
        await deleteDoc(doc(db, "references", id));
        renderReferencesAdmin();
    }
}

// Services Management
window.renderServicesAdmin = async function () {
    const list = document.getElementById('services-admin-list');
    if (!list) return;
    try {
        const q = query(collection(db, "services"), orderBy("order", "asc"));
        const snap = await getDocs(q);
        list.innerHTML = '';
        snap.forEach(docSnap => {
            const service = docSnap.data();
            const card = document.createElement('div');
            card.className = 'service-card';
            card.innerHTML = `
                <div><strong>${service.title}</strong><br><small>${service.items.length} madde</small></div>
                <button class="btn-icon" onclick="editService('${docSnap.id}')"><i data-lucide="edit"></i></button>
            `;
            list.appendChild(card);
        });
        if (typeof lucide !== 'undefined') lucide.createIcons();
    } catch (err) { console.error(err); }
}

window.editService = async function (id) {
    const snap = await getDoc(doc(db, "services", id));
    if (!snap.exists()) return;
    const service = snap.data();
    document.getElementById('service-edit-id').value = id;
    document.getElementById('service-title').value = service.title;
    document.getElementById('service-icon').value = service.icon;
    document.getElementById('service-items').value = service.items.join('\n');
    document.getElementById('service-editor').style.display = 'block';
    window.scrollTo(0, document.body.scrollHeight);
}

window.hideServiceForm = function () {
    document.getElementById('service-editor').style.display = 'none';
}

function setupEventListeners() {
    // Reference Upload
    const refUpload = document.getElementById('ref-logo-upload');
    if (refUpload) {
        refUpload.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            if (!file) return;
            const name = prompt("Referans Adı:");
            if (!name) return;
            const path = 'logos/' + Date.now() + '_' + file.name;
            const storageRef = ref(storage, path);
            const snapshot = await uploadBytesResumable(storageRef, file);
            const url = await getDownloadURL(snapshot.ref);
            await addDoc(collection(db, "references"), { name, logo: url, order: 99 });
            renderReferencesAdmin();
        });
    }

    // Service Form
    const serviceForm = document.getElementById('service-form');
    if (serviceForm) {
        serviceForm.onsubmit = async (e) => {
            e.preventDefault();
            const id = document.getElementById('service-edit-id').value;
            const data = {
                title: document.getElementById('service-title').value,
                icon: document.getElementById('service-icon').value,
                items: document.getElementById('service-items').value.split('\n').filter(i => i.trim())
            };
            await updateDoc(doc(db, "services", id), data);
            hideServiceForm();
            renderServicesAdmin();
        };
    }

    // Post Cover Upload
    const coverUpload = document.getElementById('cover-upload');
    if (coverUpload) {
        coverUpload.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            if (!file) return;
            const path = 'covers/' + Date.now() + '_' + file.name;
            const storageRef = ref(storage, path);
            const uploadTask = uploadBytesResumable(storageRef, file);
            uploadTask.on('state_changed', null, null, async () => {
                const url = await getDownloadURL(uploadTask.snapshot.ref);
                document.getElementById('image').value = url;
                alert("Fotoğraf yüklendi!");
            });
        });
    }

    // Post Form
    const postForm = document.getElementById('post-form');
    if (postForm) {
        postForm.onsubmit = async (e) => {
            e.preventDefault();
            const id = document.getElementById('edit-id').value;
            const postData = {
                title: document.getElementById('title').value,
                category: document.getElementById('category').value,
                excerpt: document.getElementById('excerpt').value,
                tldr: document.getElementById('tldr').value || '',
                content: quill ? quill.root.innerHTML : '',
                image: document.getElementById('image').value || '/cover.png',
                author: document.getElementById('author').value || 'Le Chatbot',
                date: document.getElementById('date').value,
                updatedAt: new Date().toISOString()
            };
            if (!id) {
                postData.createdAt = new Date().toISOString();
                await addDoc(collection(db, "posts"), postData);
            } else {
                await updateDoc(doc(db, "posts", id), postData);
            }
            alert('Kaydedildi!');
            cancelEdit();
            renderAdminList();
        };
    }
}
